import React, { useState } from "react";
import Alert from "../../alert/FaqAlert";
import { useTranslation } from "react-i18next";
const LUXDialog = require("luna-rocket/LUXDialog").default;

function TopBanner(props: {
  setQuestionDialog: React.Dispatch<React.SetStateAction<boolean>>;
  clickQuestionButton: () => void;
}): JSX.Element {
  const { t } = useTranslation();
  const { clickQuestionButton } = props;
  const [alert, setAlert] = useState(false);

  const onClickManualDownload = () => {
    // 교재다운로드 링크 변경 
    const manualLink: string = "https://help.douzone.com/data/file/4a073887359a53cee24d25c47067f05f.pdf";
    window.open(manualLink);

    if (manualLink === "") {
      LUXDialog.alert(t("contentsPreparingMessage"), {
        type: 'info',
        title: t("contentsPreparingTitle"),
        useRenewalStyle: true,
      });
      return;
    }
  };

  return (
    <>
      <div className="top_showcase">
        <div className="section">
          <div className="align_wh">
            <div className="heading_bx">
              <h2 className="title">{t("title")}</h2>
              <p className="sub_text">{t("subText")}</p>
              <div className="btn_linkbx">
                <button
                  type="button"
                  className="btn_top_link"
                  onClick={onClickManualDownload}
                >
                  {t("download")}
                  <span className="sp_evg"></span>
                </button>

                <button
                  type="button"
                  className="btn_top_link"
                  onClick={clickQuestionButton}
                >
                  {t("inquiryRegistration2")}
                  <span className="sp_evg"></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {alert && <Alert setAlert={setAlert} />}
    </>
  );
}

export default TopBanner;
